module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("alSYM"))).then(() => parcelRequire('fThBo'));